import { useAtom } from '@reatom/npm-react'
import { memo } from 'react'

import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { VolumeShortFormatted } from '@root/shared/core/format'
import { useTranslation } from '@root/shared/localization'

import { TradingPairExploreItemMetricsItem } from './pair-explore-item-metrics-item'

import type { PairMetrics, PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  volumePeriod: PairMetrics.MetricsSpan
} & ClassNameProps

export const TradingPairExploreItemMetricsVolume = memo(
  ({ pair, className, volumePeriod }: Props) => {
    const { t } = useTranslation()
    const [volumeUsd] = useAtom(pair.stats[volumePeriod].volumeUsd)

    return (
      <TradingPairExploreItemMetricsItem className={className}>
        <TradingPairExploreItemMetricsItem.Label>
          {t('common.volume_char')}
        </TradingPairExploreItemMetricsItem.Label>
        <FlashTextContentDistinct>
          <VolumeShortFormatted volume={volumeUsd} />
        </FlashTextContentDistinct>
      </TradingPairExploreItemMetricsItem>
    )
  },
)
